var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, prop: _vm.code, rules: _vm.rules } },
    [
      _c(
        "el-input",
        _vm._b(
          {
            attrs: { disabled: _vm.disabled },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          },
          "el-input",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }